import { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';
import { formatPhoneNumber } from '../../../../../Utils/phoneUtils';

import FetchModule from '../../../../Share/Network/FetchModule';
import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import SortingModule from '../../../../Share/Normal/SortingModule';

import SearchInput from '../../../../../View/Message/Model/SearchInput';
import SelectGenderBox from '../../../../../Component/MemberComponent/MemberDetail/SelectGenderBox';
import UserProfile from '../../../../../Component/Normal/UserProfile';
import SelectHoldingStateBox from '../../../../../Component/MemberComponent/MemberDetail/SelectHoldingStateBox';
import NewDayCountInput from '../../../../../Component/MemberComponent/MemberDetail/NewDayCountInput';
import NewCountInput from '../../../../../Component/MemberComponent/MemberDetail/NewCountInput';
import NewDayReasonInput from '../../../../../Component/MemberComponent/MemberDetail/NewDayReasonInput';
import UpwardCalenderInput from '../../../../../Component/MemberComponent/MemberDetail/NewUpwardCalendarInput';
import SelectStatusBox from '../../../../../Component/MemberComponent/MemberDetail/SelectStatusBox';
import SelectMembershipBox from '../../../../../Component/MemberComponent/MemberDetail/SelectMembershipBox';

import { ReactComponent as SortingButtonSvg } from '../../../../../image/SortingButton.svg';
import DefaultProfile from '../../../../../image/DefaultProfile.png';
import { ReactComponent as CheckSvg } from '../../../../../image/Check2.svg';
import { ReactComponent as SearchIconComponent } from '../../../../../image/Searching.svg';
import { ReactComponent as SearchIconSvg } from '../../../../../image/Searching.svg';

export default function ExtendAddModal(props) {
  const { memberData, usageId, membershipName, onClickAdditionButton, onClickExit } = props;
  const { t, languageMode } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isFirst, setIsFirst] = useState(true);
  const [memberName, setMemberName] = useState('');
  const [memberProfile, setMemberProfile] = useState('');

  const [memberships, setMemberships] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [members, setMembers] = useState([]);
  const [originalSortedMembers, setOriginalSortedMembers] = useState([]);
  const [sortedMembers, setSortedMembers] = useState([]);
  const [notPaginationSortedMembers, setNotPaginationSortedMembers] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const [isClickedValidSorting, setIsClickedValidSorting] = useState(false);
  const [isClickedExpectedSorting, setIsClickedExpectedSorting] = useState(false);

  const [isClickedMaleSorting, setIsClickedMaleSorting] = useState(false);
  const [isClickedFemaleSorting, setIsClickedFemaleSorting] = useState(false);

  const [isClickedHoldingSorting, setIsClickedHoldingSorting] = useState(false);
  const [isClickedMaintainSorting, setIsClickedMaintainSorting] = useState(false);

  const [selectedMemberships, setSelectedMemberships] = useState([]);

  const [startSort, setStartSort] = useState('normal');
  const [endSort, setEndSort] = useState('desc');

  const [isClickedCalendar, setIsClickedCalendar] = useState(false);
  const [isClickedAllMemberSelect, setIsClickedAllMemberSelect] = useState(false);
  const [nowPage, setNowPage] = useState(0);
  const [totalPage, setTotalPage] = useState(1);

  const [reason, setReason] = useState('');
  const [extendsDays, setExtendsDays] = useState(0);
  const [extendsCount, setExtendsCount] = useState(0);
  const [startDate, setStartDate] = useState(moment().format('YYYY.MM.DD'));

  const [isClickedAdditionMember, setIsClickedAdditionMemeber] = useState(false);

  // 회원 사진 및 이름 정리 //
  useEffect(() => {
    if (memberData === undefined) {
      setMemberName('');
      setMemberProfile('');
    }
    else {
      setMemberName(memberData.name);
      setMemberProfile(memberData.profile);
    }
  }, [memberData])

  // 회원 및 회원권 정보 API호출 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/valid/include_hold', 'GET');


        if (responseData.status === 200) {
          setMemberships(responseData.data.memberships);
          setMemberList(responseData.data.members);
        }
      }
    )();
  }, [])

  // 회원 선택 체크 변수 처리 //
  useEffect(() => {
    let newMembers = memberList.slice();
    let count = 0;

    newMembers.map((data) => {
      if (data.isClicked) count += 1;
    });

    if (count === newMembers.length) setIsClickedAllMemberSelect(true);
    else setIsClickedAllMemberSelect(false);

    newMembers = SortingModule.dataSort(newMembers, 'endDate', 'desc', 'endDate');

    setMembers(newMembers);
    setOriginalSortedMembers(newMembers);
  }, [memberList])

  // 회원정보 정렬 //
  useEffect(() => {
    if (members.length === 0) setSortedMembers([]);
    else {
      let newMembers = [];

      let filterMembers = [];
      let standardDate = moment(startDate, 'YYYY.MM.DD');

      for (let i = 0; i < members.length; i++) {
        // 연장 적용일 기준 유효회원 뽑기 //
        if (moment(members[i].endDate).isAfter(standardDate)) {
          // 적용일 기준 홀딩 여부 확인 //
          let isHolding = false;

          for (let j = 0; j < members[i].holdings.length; j++) {
            if (moment(members[i].holdings[j].startDate).isBefore(standardDate)
              && moment(members[i].holdings[j].endDate).isAfter(standardDate)) {
              isHolding = true;
              break;
            }
          }

          members[i].isHolding = isHolding;

          filterMembers.push(members[i]);
        }
      }

      // 유효, 예정 상태 추출 데이터 //
      let statusMembers = [];

      // 상태 둘다 체크되어있거나 둘다 체크하지 않은 경우//
      if ((isClickedValidSorting && isClickedExpectedSorting)
        || (!isClickedValidSorting && !isClickedExpectedSorting)) {
        statusMembers = filterMembers;
      }
      // 유효 회원권만 체크된 경우 //
      else if (isClickedValidSorting) {
        filterMembers.map((data, index) => {
          if (moment(data.startDate).isBefore(standardDate)
            && moment(data.endDate).isAfter(standardDate)) statusMembers.push(data);
        })
      }
      // 예정 회원권만 체크된 경우 //
      else if (isClickedExpectedSorting) {
        filterMembers.map((data) => {
          if (moment(data.startDate).isAfter(standardDate)
            && moment(data.endDate).isAfter(standardDate)) statusMembers.push(data);
        })
      }

      // 성별구분 추출 데이터 //
      let genderCheckMembers = [];

      // 성별 둘다 체크되어있거나 둘다 체크하지 않은 경우//
      if ((isClickedFemaleSorting && isClickedMaleSorting)
        || (!isClickedFemaleSorting && !isClickedMaleSorting)) {
        genderCheckMembers = statusMembers;
      }
      // 여성만 체크된 경우 //
      else if (isClickedFemaleSorting) {
        statusMembers.map((data) => {
          if (data.gender === 'female') genderCheckMembers.push(data);
        })
      }
      // 남성만 체크된 경우 //
      else if (isClickedMaleSorting) {
        statusMembers.map((data) => {
          if (data.gender === 'male') genderCheckMembers.push(data);
        })
      }

      // 홀딩구분 추출 데이터 //
      let holdingCheckMembers = [];

      // 홀딩, 사용 둘다 체크되어있거나 둘다 체크하지 않은 경우//
      if ((isClickedHoldingSorting && isClickedMaintainSorting)
        || (!isClickedHoldingSorting && !isClickedMaintainSorting)) {
        holdingCheckMembers = genderCheckMembers;
      }
      // 홀딩만 체크된 경우 //
      else if (isClickedHoldingSorting) {
        genderCheckMembers.map((data) => {
          if (data.isHolding) holdingCheckMembers.push(data);
        })
      }
      // 사용만 체크된 경우 //
      else if (isClickedMaintainSorting) {
        genderCheckMembers.map((data) => {
          if (!data.isHolding) holdingCheckMembers.push(data);
        })
      }

      let membershipCheckMembers = [];

      if (selectedMemberships.length === 0) membershipCheckMembers = holdingCheckMembers;
      else {
        holdingCheckMembers.map((data) => {
          for (let i = 0; i < selectedMemberships.length; i++) {
            if (data.membershipName === selectedMemberships[i].membershipName) {
              membershipCheckMembers.push(data);
              break;
            }
          }
        })
      }

      if (startSort === 'asc') membershipCheckMembers = SortingModule.dataSort(membershipCheckMembers, 'startDate', 'asc', 'startDate');
      else if (startSort === 'desc') membershipCheckMembers = SortingModule.dataSort(membershipCheckMembers, 'startDate', 'desc', 'startDate');
      else if (endSort === 'asc') membershipCheckMembers = SortingModule.dataSort(membershipCheckMembers, 'endDate', 'asc', 'endDate');
      else if (endSort === 'desc') membershipCheckMembers = SortingModule.dataSort(membershipCheckMembers, 'endDate', 'desc', 'endDate');

      let nameList = [];
      let phoneList = [];

      for (let i = 0; i < membershipCheckMembers.length; i++) {
        if (membershipCheckMembers[i].name.toLowerCase().includes(searchValue.toLowerCase())) nameList.push(membershipCheckMembers[i]);
        else if (membershipCheckMembers[i].phone.includes(searchValue)) phoneList.push(membershipCheckMembers[i]);
      }

      if (nameList.length === 0 && phoneList.length === 0) {
        for (let i = 0; i < membershipCheckMembers.length; i++) {
          if (match(searchValue.toLowerCase(), membershipCheckMembers[i].name.toLowerCase())) nameList.push(membershipCheckMembers[i]);
        }
      }

      let totalList = nameList.concat(phoneList);

      if (totalList.length > 10) {
        let finalPage = Math.ceil(totalList.length / 10);

        if (nowPage >= finalPage) setNowPage(finalPage - 1);

        setTotalPage(finalPage);
      }
      else {
        setNowPage(0);
        setTotalPage(1);
      }

      // 페이지 분리 //
      if (totalList.length !== 0) {
        if (totalList.length > 10) newMembers = totalList.slice((nowPage * 10), (nowPage * 10) + 10);
        else newMembers = totalList.slice();
      }

      // setOriginalSortedMembers(totalList);
      setSortedMembers(newMembers);
      setNotPaginationSortedMembers(totalList);
      setIsClickedAllMemberSelect(false);
    }
  },
    [
      members,
      searchValue,
      isClickedValidSorting,
      isClickedExpectedSorting,
      isClickedHoldingSorting,
      isClickedMaintainSorting,
      isClickedMaleSorting,
      isClickedFemaleSorting,
      selectedMemberships,
      startSort,
      endSort,
      nowPage,
      startDate,
      match()
    ])

  useEffect(() => {
    if (!isFirst || notPaginationSortedMembers.length === 0) return;

    let newDates = notPaginationSortedMembers.slice();

    newDates.map((data) => {
      if (data.usageId === usageId) data.isClicked = true;
      else data.isClicked = false;
    })

    setIsFirst(false);
    setNotPaginationSortedMembers(newDates);
  }, [isFirst, usageId, notPaginationSortedMembers])

  // 몇명 선택되었는지 텍스트 표출 //
  function decideSelectedCountText() {
    let count = 0;

    originalSortedMembers.map((data) => {
      if (data.isClicked) count += 1;
    })

    return count + t('memberDetail.extensionModal.personSuffix');
  }

  // 입력된 글자가 한글인지 확인 //
  function is_kr(value) {
    if (value === undefined) return false;

    return ((('ㄱ'.charCodeAt() <= value.charCodeAt()) && (value.charCodeAt() <= 'ㅎ'.charCodeAt()))
      || (('가'.charCodeAt() <= value.charCodeAt()) && value.charCodeAt() <= '힣'.charCodeAt()));
  }

  // 한글 글자 유니코드 추출하여 검색 조건 확인 //
  function kr_num(value) {
    return value.charCodeAt() - '가'.charCodeAt();
  }

  // 초성 중성 종성 구분하여 연산 //
  function kr_list(value) {
    const consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
      , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    let res = [value];

    let kr_num_s = kr_num(value);

    if (kr_num_s > 0) {
      // 초성 + 중성일 경우 //
      if (kr_num_s % 28 !== 0) {
        res.push(String.fromCharCode(((parseInt(kr_num_s / 28) * 28) + '가'.charCodeAt())));
      }

      res.push(consonant_list[parseInt(kr_num_s / 588)])
    }

    return res;
  }

  // 한글, 영어 구분하여 검색 처리 //
  function eq_kr(value, data) {
    if (is_kr(value) && is_kr(data)) {
      return kr_list(data).includes(value);
    }
    else return value === data;
  }

  // 받침 확인하기 //
  function eq_kr_pos(value, data, nextData) {
    const consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
      , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    const kr_pos = [
      [0, 0], [1, 0], [2, 1], [2, 9], [4, 2], [1, 12], [2, 18],
      [7, 3], [8, 5], [1, 0], [2, 6], [3, 7], [4, 9], [5, 16],
      [6, 17], [7, 18], [16, 6], [17, 7], [1, 9], [19, 9], [20, 10],
      [21, 11], [22, 12], [23, 14], [24, 15], [25, 16], [26, 17], [27, 18]
    ]

    if (!(is_kr(value) && is_kr(data) && is_kr(nextData))) return false;
    if (kr_num(value) < 0) return false;

    let s_pos = String.fromCharCode(value.charCodeAt() - kr_pos[kr_num(value) % 28][0])
    let s_pos_consonant = consonant_list[kr_pos[kr_num(value) % 28][1]]

    return (s_pos === data) && (kr_list(nextData).includes(s_pos_consonant));
  }

  // 일치하는 글자가 존재하는지 확인 //
  function match(value, data) {
    if (value === undefined || data === undefined) return false;

    const valueSize = value.length;
    const dataSize = data.length;

    if (dataSize < valueSize) return false;

    for (let i = 0; i < (dataSize - valueSize + 1); i++) {
      let res = true;

      for (let j = 0; j < valueSize; j++) {
        if (j === (valueSize - 1)) {
          if (!eq_kr(value[j], data[i + j])) {
            if (i + j + 1 < dataSize) {
              if (eq_kr_pos(value[j], data[i + j], data[i + j + 1])) {
                break;
              }
            }
            res = false;
            break;
          }
        }
        else {
          if (value[j] !== data[i + j]) {
            res = false;
            break;
          }
        }
      }

      if (res) return true;
    }

    return false;
  }

  // 필터 초기화 클릭시 //
  function onClickResetFilter() {

    let newOriginalSortedMembers = originalSortedMembers.slice();

    newOriginalSortedMembers.map((data) => data.isClicked = false);

    setOriginalSortedMembers(newOriginalSortedMembers);
    setNotPaginationSortedMembers(newOriginalSortedMembers);

    setSearchValue('');
    setIsClickedMaleSorting(false);
    setIsClickedFemaleSorting(false);
    setIsClickedAllMemberSelect(false);
    setStartSort('normal');
    setEndSort('desc');
  }

  // 시작일 정렬 버튼 클릭시 //
  function onClickStartSort() {
    setEndSort('normal');

    if (startSort === 'normal' || startSort === 'desc') setStartSort('asc');
    else if (startSort === 'asc') setStartSort('desc');
  }

  // 종료일 정렬 버튼 클릭시 //
  function onClickEndSort() {
    setStartSort('normal');

    if (endSort === 'normal' || endSort === 'desc') setEndSort('asc');
    else if (endSort === 'asc') setEndSort('desc');
  }

  // 전체선택 클릭시 //
  function onClickAllSelectButton() {
    let newNotPaginationSortedMembers = notPaginationSortedMembers.slice();

    newNotPaginationSortedMembers.map((data) => data.isClicked = !isClickedAllMemberSelect);

    setNotPaginationSortedMembers(newNotPaginationSortedMembers);
    setIsClickedAllMemberSelect(!isClickedAllMemberSelect);
  }

  // 페이지네이션 이전버튼 클릭시 //
  function onClickPrevButton() {
    if (nowPage !== 0) {
      setNowPage(nowPage - 1);
    }
  }

  // 페이지네이션 다음버튼 클릭시 //
  function onClickNextButton() {
    if ((nowPage + 1) !== totalPage) {
      setNowPage(nowPage + 1);
    }
  }

  // 회원 선택시 //
  function onClickMemberInfo(data) {
    let newOriginalSortedMembers = originalSortedMembers.slice();
    let index = newOriginalSortedMembers.findIndex(item => item.usageId === data.usageId);

    if (newOriginalSortedMembers[index].isClicked) setIsClickedAllMemberSelect(false);

    newOriginalSortedMembers[index].isClicked = !newOriginalSortedMembers[index].isClicked;

    setOriginalSortedMembers(newOriginalSortedMembers);
  }

  // 회원 선택목록에서 제외버튼 클릭시 //
  function onClickDeleteButton(data) {
    let newOriginalSortedMembers = originalSortedMembers.slice();
    let index = newOriginalSortedMembers.findIndex(item => item.memberId === data.memberId);

    if (newOriginalSortedMembers[index].isClicked) setIsClickedAllMemberSelect(false);

    newOriginalSortedMembers[index].isClicked = !newOriginalSortedMembers[index].isClicked;

    setOriginalSortedMembers(newOriginalSortedMembers);
  }

  // 연장하기 버튼 클릭시 //
  function onClickAddition() {
    let days = extendsDays;

    if (days === 0 && extendsCount === 0) {
      alert(t('memberDetail.extensionModal.alertSetExtensionDaysOrSessions'));
      return;
    }

    let usageIds = [];

    originalSortedMembers.map((data) => {
      if (data.isClicked) usageIds.push(data.usageId);
    })

    let requestData = {
      usageIds: usageIds,
      applyDate: moment(startDate, 'YYYY.MM.DD').format('YYYY-MM-DDTHH:mm:ss'),
      plusTotalMax: extendsCount,
      days: days,
      reason: reason
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('membership/extends', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('memberDetail.extensionModal.alertExtensionApplied'));
          onClickExit();
        }
        else if (responseData.status === 201) {
          alert(responseData.error);
        }
      }
    )();
  }

  // 달력 클릭시 //
  function calenderClick() {
  }

  return (
    <TotalModalWrapper>
      <Modal isClickedAdditionMember={isClickedAdditionMember} isClickedCalendar={isClickedCalendar} $isDark={isDark}>
        <ModalInnerWrapper>
          <TopLineWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} hover='default'>{t('memberDetail.extensionModal.extendModifyTitle')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>{t('memberDetail.extensionModal.extendAddDesc')}</Text>
            </TitleWrapper>
            <ButtonWrapper>
              <ExitButton onClick={onClickExit}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='pointer'>{t('memberDetail.modalCancel')}</Text>
              </ExitButton>
              <AdditionButton onClick={onClickAddition}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('memberDetail.extensionModal.btnExtend')}</Text>
              </AdditionButton>
            </ButtonWrapper>
          </TopLineWrapper>
          {
            !isClickedAdditionMember &&
            <MemberInfoBox>
              <ProfileBox>
                <UserProfile profile={memberProfile} defaultProfile={DefaultProfile} />
              </ProfileBox>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{memberName}</Text>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{membershipName}</Text>
            </MemberInfoBox>
          }
          {!isClickedAdditionMember && <DivisionLine style={{ margin: '17px 0px' }} width='100%' />}
          <ExtendsDataWrapper isClickedAdditionMember={isClickedAdditionMember}>
            <ExtendsLeftDataWrapper>
              <NewDayCountInput value={extendsDays} setValue={setExtendsDays} />
              <NewCountInput value={extendsCount} setValue={setExtendsCount} />
            </ExtendsLeftDataWrapper>

            <CalendarInputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} hover='default'>{t('memberDetail.extensionModal.extensionApplyDate')}</Text>
              <UpwardCalenderInput
                disabled={false}
                value={startDate}
                setValue={setStartDate}
                className='StartCalender'
                clickFn={calenderClick}
                placeholder={t('memberDetail.extensionModal.startDate')}
                width={171}
                isClicked={isClickedCalendar}
                setIsClicked={setIsClickedCalendar} />
            </CalendarInputWrapper>
          </ExtendsDataWrapper>
          <ExtendsReasonBoxWrapper>
            <NewDayReasonInput value={reason} setValue={setReason} />
          </ExtendsReasonBoxWrapper>
          {
            !isClickedAdditionMember &&
            <AdditionMemberButtonWrapper>
              <AdditionMemberButton onClick={() => setIsClickedAdditionMemeber(true)}>
                <SearchIcon />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('memberDetail.extensionModal.addExtendMember')}</Text>
              </AdditionMemberButton>
            </AdditionMemberButtonWrapper>
          }
          {
            isClickedAdditionMember &&
            <AdditionMemberView>
              <DivisionLine style={{ margin: '30px 0px' }} width='100%' />
              <SearchInputWrapper>
                <SearchInput value={searchValue} setValue={setSearchValue} placeholder={t('memberDetail.extensionModal.searchMember')} width={372} />
              </SearchInputWrapper>
              <ResetAndSortingButtonWrapper>
                <SortingButtonWrapper>
                  <SelectStatusBox
                    isClickedValidSorting={isClickedValidSorting}
                    isClickedExpectedSorting={isClickedExpectedSorting}
                    setIsClickedValidSorting={setIsClickedValidSorting}
                    setIsClickedExpectedSorting={setIsClickedExpectedSorting} />

                  <SelectGenderBox
                    isClickedMaleSorting={isClickedMaleSorting}
                    isClickedFemaleSorting={isClickedFemaleSorting}
                    setIsClickedMaleSorting={setIsClickedMaleSorting}
                    setIsClickedFemaleSorting={setIsClickedFemaleSorting} />

                  <SelectHoldingStateBox
                    isClickedHoldingSorting={isClickedHoldingSorting}
                    isClickedMaintainSorting={isClickedMaintainSorting}
                    setIsClickedHoldingSorting={setIsClickedHoldingSorting}
                    setIsClickedMaintainSorting={setIsClickedMaintainSorting} />

                  <SelectMembershipBox
                    value={selectedMemberships}
                    setValue={setSelectedMemberships}
                    memberships={memberships} />

                </SortingButtonWrapper>
                <FilterResetButton onClick={onClickResetFilter}>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='pointer'>{t('memberDetail.extensionModal.resetFilter')}</Text>
                </FilterResetButton>
              </ResetAndSortingButtonWrapper>

              <TotalMemberBoxWrapper>
                <TotalMemberBox>
                  <TotalMemberColumnWrppaer>
                    <MemberCheckBox isClicked={isClickedAllMemberSelect} onClick={onClickAllSelectButton}>
                      {isClickedAllMemberSelect && <CheckIcon />}
                    </MemberCheckBox>
                    <TextWrapper marginLeft={10} width={120}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('memberDetail.colName')}</Text>
                    </TextWrapper>
                    <TextWrapper marginLeft={10} width={50}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('memberDetail.labelGender')}</Text>
                    </TextWrapper>
                    {/* <TextWrapper marginLeft={5} width={84}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('memberDetail.labelBirth')}</Text>
                    </TextWrapper> */}
                    <TextWrapper marginLeft={10} width={190}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('memberDetail.extensionModal.membership')}</Text>
                    </TextWrapper>
                    <AscDescButtonWrapper marginLeft={10} width={75}>
                      <TextWrapper width={40}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('memberDetail.extensionModal.startDate')}</Text>
                      </TextWrapper>
                      <SortingButton $sort={startSort} onClick={() => onClickStartSort()} />
                    </AscDescButtonWrapper>
                    <AscDescButtonWrapper marginLeft={10} width={75}>
                      <TextWrapper width={40}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('memberDetail.extensionModal.endDate')}</Text>
                      </TextWrapper>
                      <SortingButton $sort={endSort} onClick={() => onClickEndSort()} />
                    </AscDescButtonWrapper>
                    <PaginationWrapper style={{ marginLeft: '28px' }}>
                      <PaginationButton isAvailableClick={nowPage !== 0} onClick={onClickPrevButton}>
                        <LeftPaginationTriangle />
                      </PaginationButton>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{(nowPage + 1) + '/' + totalPage}</Text>
                      <PaginationButton isAvailableClick={(nowPage + 1) !== totalPage} onClick={onClickNextButton}>
                        <RightPaginationTriangle />
                      </PaginationButton>
                    </PaginationWrapper>
                  </TotalMemberColumnWrppaer>
                  <TotalMemberListWrapper>
                    {
                      sortedMembers.map((data, index) => (
                        <TotalMemberInfo key={'TotalSendMember-' + index} onClick={() => onClickMemberInfo(data)}>
                          <MemberCheckBox isClicked={data.isClicked}>
                            {data.isClicked && <CheckIcon />}
                          </MemberCheckBox>
                          <TextWrapper marginLeft={10} width={120}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.name}</Text>
                          </TextWrapper>
                          <TextWrapper marginLeft={10} width={50}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.gender === 'male' ? t('memberDetail.male') : t('memberDetail.female')}</Text>
                          </TextWrapper>
                          {/* <TextWrapper marginLeft={5} width={84}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.birth.slice(2, 4) + '.' + data.birth.slice(4, 6) + '.' + data.birth.slice(6, 8)}</Text>
                          </TextWrapper> */}
                          <TextWrapper marginLeft={10} width={190}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.membershipName}</Text>
                          </TextWrapper>
                          <TextWrapper marginLeft={10} width={75}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{moment(data.startDate).format(t('calendarInput.dateFormat'))}</Text>
                          </TextWrapper>
                          <TextWrapper marginLeft={10} width={75}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{moment(data.endDate).format(t('calendarInput.dateFormat'))}</Text>
                          </TextWrapper>
                          {/* {
                            (moment(data.endDate).diff(moment(), 'day') >= 0 && moment(data.endDate).diff(moment(), 'day') <= 5) &&
                            <TextWrapper marginLeft={54} width={45}>
                              <Dday>{moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day') === 0 ? 'D-day' : 'D-' + moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day')}</Dday>
                            </TextWrapper>
                          } */}
                          {
                            true &&
                            <TextWrapper marginLeft={25} width={80}>
                              <Dday>{t('memberDetail.statusHoldingInProgress')}</Dday>
                            </TextWrapper>
                          }
                        </TotalMemberInfo>
                      ))
                    }
                  </TotalMemberListWrapper>
                </TotalMemberBox>
                <SelectedMemberBoxWrapper>
                  <SelectedTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.subText} hover='default'>{t('memberDetail.extensionModal.currentlyPrefix')}</Text>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.primary} hover='default'>{decideSelectedCountText()}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.subText} hover='default'>{t('memberDetail.extensionModal.selectedSuffix')}</Text>
                  </SelectedTextWrapper>
                  <DivisionLine width='194px' marginTop={10} />
                  <SelectedMemberBox>
                    <SelectedMemberInfoWrapper>
                      {
                        originalSortedMembers.map((data, index) => (
                          data.isClicked &&
                          <SelectedMemberInfo key={'SelectedSortMember-' + index}>
                            <ProfileWrapper isFirst={index === 0} isLast={originalSortedMembers.length - 1 === index}>
                              <UserProfile profile={data.profile} defaultProfile={DefaultProfile} />
                            </ProfileWrapper>
                            <InfoWrapper>
                              <TextWrapper marginLeft={10}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{data.name}</Text>
                              </TextWrapper>
                              <TextWrapper marginLeft={10}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} hover='default'>{formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('memberDetail.noPhone')}</Text>
                              </TextWrapper>
                            </InfoWrapper>
                            <DeleteButtonWrapper onClick={() => onClickDeleteButton(data)}>
                              <DeleteButton>
                                <Stick width={13} height={2} radius={5} backgroundColor={theme.line} />
                                <Stick width={2} height={13} radius={5} backgroundColor={theme.line} />
                              </DeleteButton>
                            </DeleteButtonWrapper>
                          </SelectedMemberInfo>
                        ))
                      }
                    </SelectedMemberInfoWrapper>
                  </SelectedMemberBox>
                </SelectedMemberBoxWrapper>
              </TotalMemberBoxWrapper>
            </AdditionMemberView>
          }
        </ModalInnerWrapper>
      </Modal>
    </TotalModalWrapper>
  )
}
const Modal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  // margin: 0 auto;

  padding: 20px 0;

  box-sizing: border-box;
  width: 1024px;
  // height: 662px;
  // height: ${props => props.isClickedAdditionMember ? `889px` : `457px`};
  // height: ${props => props.isClickedAdditionMember ? `869px` : `417px`};
  height: ${props => props.isClickedAdditionMember ? `869px` : `356px`};

  overflow: ${props => props.isClickedCalendar ? `visible` : `hidden`};

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const ModalInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: calc(100% - 40px);
  // height: 626px;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const AdditionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const AdditionMemberView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const SearchInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // margin-top: 20px;

  width: 100%;
`;

const ResetAndSortingButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 20px;

  width: 100%;
`;

const SortingButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 14px;
`;

const FilterResetButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 10px;

  height: 31px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalMemberBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 20px;

  width: 984px;
  // height: 473px;
  height: 409px;

  gap: 20px;
`;

const TotalMemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 723px;
  height: 300px;
`;

const TotalMemberColumnWrppaer = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  // padding: 0px 6px;
  padding-left: 6px;

  width: calc(100% - 6px);
`;

const MemberCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.subText}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: ${props => props.marginLeft}px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
  min-width: 0;
  height: 20px;

  overflow: hidden;
`;

const AscDescButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: ${props => props.marginLeft}px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const SortingButton = styled(SortingButtonSvg)`
  margin-left: 4px;
  flex-shrink: 0;

  width: 20px;
  height: 20px;

  transform: ${props => props.$sort === 'asc' ? 'rotate(180deg)' : 'none'};

  & rect {
    fill: ${props => props.$sort !== 'normal' ? props.theme.primary : props.theme.buttonFill3};
    transition: fill 0.3s ease-in-out;
  }

  & path:first-of-type {
    fill: ${props => props.$sort !== 'normal' ? props.theme.subBackground : props.theme.white};
    transition: fill 0.3s ease-in-out;
  }

  & path:last-of-type {
    fill: ${props => props.$sort !== 'normal' ? props.theme.subBackground : props.theme.white};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalMemberListWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 15px;

  width: 100%;
  min-height: 430px;
  max-height: 430px;

  gap: 5px;
`;

const TotalMemberInfo = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 6px;

  width: calc(100% - 12px);
  height: 35px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PaginationTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 100%;
`;

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const PaginationButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  border-radius: 4px;
  background-color: ${props => props.isAvailableClick ? props.theme.primary : props.theme.buttonFill3};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const LeftPaginationTriangle = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 7px 5px 0px;
  border-color: transparent ${props => props.theme.white} transparent transparent;
`;

const RightPaginationTriangle = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0px 5px 7px;
  border-color: transparent transparent transparent ${props => props.theme.white};
`;

const SelectedMemberBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 241px;
`;

const SelectedTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const SelectedMemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;
  
  width: 241px;
  height: 378px;

  overflow-x: hidden;
  overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.line};
		border: 3px solid transparent;
		height: 25px;
		// background-color: #FF8B48;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const SelectedMemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 224px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const SelectedMemberInfo = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 44px;

  background-color: ${props => props.theme.subBackground};
`;

const ProfileWrapper = styled.div`
  flex-shrink: 0;
  width: 44px;
  height: 44px;

  // border-radius: 4px;
  border-top-left-radius: ${props => props.isFirst ? `4px` : `0px`};
  border-bottom-left-radius: ${props => props.isLast ? `4px` : `0px`};

  overflow: hidden;

  img {
    object-fit: cover;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  min-width: 0;
  height: 100%;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: column;

  // margin: 10px 0px;

  margin-top: ${props => props.marginTop}px;

  // width: 194px;
  width: ${props => props.width};
  height: 1px;

  border-radius: 2px;
  background-color: ${props => props.theme.line};
`;

const Dday = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 20px;

  border-radius: 10px;
  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Regular;
  font-size: 12px;
  white-space: nowrap;

  color: ${props => props.theme.subBackground};

  margin: 0 0 0 0;
`;

const DeleteButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-left: 10px;

  width: 23px;
  height: 23px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const DeleteButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  transform: rotate(45deg);
`;

const Stick = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: ${props => props.radius}px;
  background-color: ${props => props.backgroundColor};
`;

const CheckIcon = styled(CheckSvg)`
  width: 10px;
  height: auto;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const MemberInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 10px;

  width: 100%;

  gap: 10px;
`;

const ExtendsDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: ${props => props.isClickedAdditionMember ? `36px` : `0px`};

  width: 100%;
`;

const ExtendsLeftDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 30px;
`;

const ExtendsReasonBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;
`;

const CalendarInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;
`;

const AdditionMemberButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;
`;

const AdditionMemberButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 12px;
  
  height: 40px;

  gap: 4px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledSearchIcon = styled(SearchIconComponent)`
  width: 24px;
  height: 24px;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const SearchIcon = styled(SearchIconSvg)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const ProfileBox = styled.div`
  position: relative;

  width: 30px;
  height: 30px;

  border-radius: 2px;

  overflow: hidden;

  & img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;